import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["role", "tabindex", "title"]
const _hoisted_2 = ["role", "tabindex", "title"]
const _hoisted_3 = { class: "class-box-title" }
const _hoisted_4 = ["role", "tabindex", "title", "onClick", "onKeydown"]
const _hoisted_5 = { class: "class-box-markers" }
const _hoisted_6 = { class: "class-box-name" }
const _hoisted_7 = { class: "class-box-type" }
const _hoisted_8 = { class: "class-box-multiplicity" }
const _hoisted_9 = {
  key: 0,
  class: "class-box-default"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "class-box-section" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "class-box-markers" }
const _hoisted_14 = { class: "class-box-name" }
const _hoisted_15 = { class: "class-box-type" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["class-box", {'class-box-target': !_ctx.canWrite}]),
    style: _normalizeStyle(_ctx.style),
    role: _ctx.canWrite ? undefined : 'button',
    tabindex: _ctx.canWrite ? undefined : 0,
    title: _ctx.canWrite ? undefined : _ctx.$tt('collection-goto', {collection: _ctx.model.name}),
    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.canWrite || _ctx.open({kind: 'class'}))),
    onKeydown: [
      _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.canWrite || _ctx.open({kind: 'class'})), ["enter"])),
      _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (_ctx.canWrite || _ctx.open({kind: 'class'})), ["prevent"]), ["space"]))
    ]
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["class-box-header", {'class-box-target': _ctx.canWrite}]),
      role: _ctx.canWrite ? 'button' : undefined,
      tabindex: _ctx.canWrite ? 0 : undefined,
      title: _ctx.canWrite ? _ctx.$tt('collection-design-goto', {collection: _ctx.model.name}) : undefined,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.canWrite && _ctx.open({kind: 'class'}))),
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.canWrite && _ctx.open({kind: 'class'})), ["enter"])),
        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.canWrite && _ctx.open({kind: 'class'})), ["prevent"]), ["space"]))
      ]
    }, [
      _createVNode(_component_v_icon, {
        size: "small",
        start: "",
        color: "white"
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode("mdi-table", -1)
        ]))]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.model.name), 1)
    ], 42, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.compartments, (compartment) => {
      return (_openBlock(), _createElementBlock("div", {
        key: compartment.kind,
        class: "class-box-compartment"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(compartment.rows, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            key: row.alias,
            class: _normalizeClass(["class-box-row", {'is-key': row.identifier, 'class-box-target': _ctx.canWrite}]),
            role: _ctx.canWrite ? 'button' : undefined,
            tabindex: _ctx.canWrite ? 0 : undefined,
            title: _ctx.rowTitle(row),
            onClick: ($event: any) => (_ctx.canWrite && _ctx.open({kind: 'property', property: row.alias})),
            onKeydown: [
              _withKeys(($event: any) => (_ctx.canWrite && _ctx.open({kind: 'property', property: row.alias})), ["enter"]),
              _withKeys(_withModifiers(($event: any) => (_ctx.canWrite && _ctx.open({kind: 'property', property: row.alias})), ["prevent"]), ["space"])
            ]
          }, [
            _createElementVNode("span", _hoisted_5, [
              (row.identifier)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    size: "x-small",
                    color: "amber-darken-3"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("mdi-key", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (row.target)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    size: "x-small",
                    color: "teal"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.target.bidirectional ? 'mdi-arrow-left-right' : 'mdi-arrow-right'), 1)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true),
              (row.domain)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 2,
                    size: "x-small",
                    color: "orange-darken-4"
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode(" mdi-format-list-bulleted ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (row.required)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 3,
                    size: "x-small",
                    class: _normalizeClass({'conditional': row.required.condition}),
                    color: "red-darken-1"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("mdi-asterisk", -1)
                    ]))]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              (row.unique && !row.identifier)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 4,
                    size: "x-small",
                    class: _normalizeClass({'conditional': row.unique.condition}),
                    color: "blue-grey"
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("mdi-fingerprint", -1)
                    ]))]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true),
              (row.computed)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 5,
                    size: "x-small",
                    color: "purple"
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("mdi-function-variant", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_6, _toDisplayString(row.name), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(row.typeLabel), 1),
            _createElementVNode("span", _hoisted_8, _toDisplayString(row.multiplicity), 1),
            (row.defaultValue)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "= " + _toDisplayString(row.defaultValue), 1))
              : _createCommentVNode("", true)
          ], 42, _hoisted_4))
        }), 128))
      ]))
    }), 128)),
    (_ctx.model.workflow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "class-box-compartment class-box-target",
          role: "button",
          tabindex: "0",
          title: _ctx.$tt('workflow-design-named', {workflow: _ctx.model.workflow.name}),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.open({kind: 'workflow'}))),
          onKeydown: [
            _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.open({kind: 'workflow'})), ["enter"])),
            _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.open({kind: 'workflow'})), ["prevent"]), ["space"]))
          ]
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_icon, {
              size: "x-small",
              start: ""
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createTextVNode("mdi-sync", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(_ctx.model.workflow.name), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.workflow.states, (state) => {
            return (_openBlock(), _createElementBlock("div", {
              key: state.id,
              class: "class-box-row",
              title: _ctx.stateTitle(state)
            }, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_v_icon, {
                  size: "x-small",
                  color: state.color
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("mdi-circle-medium", -1)
                  ]))]),
                  _: 1
                }, 8, ["color"])
              ]),
              _createElementVNode("span", _hoisted_14, _toDisplayString(state.name), 1),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.stateMark(state)), 1)
            ], 8, _hoisted_12))
          }), 128))
        ], 40, _hoisted_10))
      : _createCommentVNode("", true)
  ], 46, _hoisted_1))
}